// i18n area 'backups' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO, che è la lingua SORGENTE (regola
// ratificata 2026-08-03); gli anglicismi del sorgente si TRASLANO secondo l'uso vivo
// islandese (safnvista = archiviare, endurheimta = ripristinare); i termini di
// contract (masterpass, keystore, merge/overwrite, reconciler, sweeper, manifest)
// restano invariati. Sidecar anti-stantie: ../meta/backups.is-IS.meta.json.
import type { enUS } from './backups'

export const isIS: typeof enUS = {
  ckpt: {
    contents: 'Tekur við',
    contentsHint:
      'Hvað má lenda hér. „Checkpoints“ er stilling klasans, „Gagnaafrit“ eru afrit sýndarvéla: lesturnar tvær bætast saman, einn áfangastaður má taka við báðum.',
    content: { checkpoints: 'Checkpoints', backups: 'Gagnaafrit' },
    destinationsTitle: 'Áfangastaðir afritunar',
    checkpointsTitle: 'Checkpoint',
    restoreTitle: 'Endurheimt',
    addDestination: 'Bæta við áfangastað',
    addDestinationTitle: 'Bæta við áfangastað afritunar',
    editDestinationTitle: 'Breyta áfangastað',
    storage: 'Geymsla',
    storageHint:
      'Geymsla af dir-gerð (dir/NFS/CIFS/CephFS) — artefaktarnir eru venjulegar skrár undir nafnrými vettvangsins.',
    schedule: 'Áætlun',
    scheduleNone: 'Aðeins handvirkt',
    scheduleHourly: 'Á klukkutíma fresti',
    scheduleDaily: 'Daglega',
    scheduleWeekly: 'Vikulega',
    scheduleHour: 'Klukkustund',
    scheduleWeekday: 'Vikudagur',
    scheduleHint:
      'Í áætluðum checkpoint-um er enginn notandi til að slá inn masterpass: leyndarmál keystore eru pökkuð sem staðgenglar.',
    retention: 'Varðveisla',
    retentionHint:
      'Hve mörg áætluð checkpoint á að geyma — sweeper fjarlægir þau elstu umfram töluna. Handvirk checkpoint og checkpoint frá því fyrir endurheimt eru aldrei fjarlægð.',
    paused: 'Í bið',
    pausedHint:
      'Myrkvun stjórnandans: á meðan biðin varir er ekkert áætlað og ekkert grisjað á þessum áfangastað — gagnastefnur jafnt sem checkpoint. Aldrei er snert við keyrslum í gangi.',
    orphanRuns: '{n} munaðarlausar keyrslur',
    orphanRunsHint:
      'Áætlaðar keyrslur frá policies sem eru ekki lengur til á þessum áfangastað: engin retention stjórnar þeim — aldrei taldar, aldrei grisjaðar — og aðeins hönd eyðir þeim. Linsan „backups“ í tvirt diagnose nefnir fjarlægðar policies.',
    rescan: 'Endurættleiða artefakta',
    rescanTitle: 'Endurættleiðing artefakta fyrir {name}',
    rescanHint:
      'Endurbyggir afritaskrána (VM/CT/App) úr manifestum artefaktanna á áfangastaðnum. Aldrei er snert við fyrirliggjandi línum; afrit óþekktra stefna verða munaðarlaus (aldrei snyrt sjálfkrafa). Skrefið eftir bootstrap-endurheimt.',
    masterpassDrWarning:
      'Hamfarasviðsmynd: LUKS-diskar koma AÐEINS til baka úr checkpoint MEÐ masterpass. Áætluð checkpoint pakka staðgenglum — taktu reglulega handvirkt checkpoint með masterpass.',
    policy: {
      title: 'Stefnur fyrir gagnaafrit',
      hint: 'Nafngreindar stefnur: hvaða hlutir (kind, merki, scope), hversu oft, hvenær keyrsla má hefjast og hve mörgum afritum skal haldið. Innritunarlátbragðið er áfram hjá eiganda hlutarins: merkin eru sett á hans eigið scope.',
      add: 'Bæta við stefnu',
      column: 'Gagnastefnur',
      name: 'Heiti',
      nameHint:
        'Merkimiði policy, einkvæmt innan áfangastaðar. Keyrslur fylgja stöðugu id policy: að endurnefna er ókeypis; að eyða henni gerir keyrslur hennar munaðarlausar (hvorki taldar né grisjaðar lengur).',
      kindLocked: 'Hlutafjölskyldu policy sem er þegar til er ekki hægt að breyta: búðu til nýja policy.',
      kindLabel: 'Hlutir',
      kind: { vm: 'Sýndarvélar', ct: 'Gámar', app: 'Öpp' },
      tags: 'Merkjaval',
      tagsHint:
        'Pör af tag=gildi, aðskilin með kommum, tengd með AND. Tóm merki og scope velja ekkert — aldrei „allt“.',
      scopes: 'Scope',
      scopesHint: 'Scope-slóðir (undirtré), aðskildar með kommum, í OR sín á milli.',
      windowStart: 'Gluggi frá',
      windowEnd: 'Gluggi til',
      windowHint:
        'Keyrslugluggi (HH:MM, staðartími; upphaf handan endans fer yfir miðnætti). Hann stýrir aðeins UPPHAFINU: keyrsla sem fer fram yfir hann er aldrei drepin.',
      mode: 'Hamur',
      modeHint: 'Stigvaxandi afritun ríður á fjölskyldu raðanna; rofin röð fellur niður í full, sagt í dagbókinni.',
      modeFull: 'Full',
      modeIncremental: 'Stigvaxandi',
      requireQuiesce: 'Krefjast quiesce (guest agent)',
      paused: 'Stefna í bið',
      retentionNone: 'Halda öllu',
      retentionCount: 'Fjöldi',
      retentionGfs: 'GFS-hringir',
      gfs: { keepLast: 'Síðustu', daily: 'Dagleg', weekly: 'Vikuleg', monthly: 'Mánaðarleg', yearly: 'Árleg' },
      gfsHint:
        'Fyrir hvern hring er nýjasta afrit hvers af síðustu N tímabilum geymt. Geymt afrit heldur allri keðju sinni á lífi — aldrei grunnur með munaðarleysingjum.',
      lastRun: 'Síðasta keyrsla',
      neverRan: 'aldrei keyrt'
    },
    lastCheckpoint: 'Síðasta checkpoint',
    neverRun: 'Aldrei tekið',
    createNow: 'Búa til checkpoint',
    createNowTitle: 'Búa til checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Ver leynileg gildi keystore (argon2id → AES-256-GCM, fyrir hvert gildi). Það er aldrei vistað: geymdu það — án þess skilar endurheimt staðgenglum í stað raunverulegra leyndarmála.',
    masterpassEmptyHint: 'Skildu eftir autt til að pakka skýrum staðgenglum í stað leyndarmála.',
    createStarted: 'Checkpoint í gangi…',
    destinationInUseError: "'{name}' geymir enn checkpoint — eyddu þeim fyrst.",
    origin: 'Uppruni',
    originManual: 'handvirkt',
    originSchedule: 'áætlað',
    originPreRestore: 'fyrir endurheimt',
    originPreChange: 'fyrir breytingu',
    preChangeRetention: 'Checkpoint fyrir breytingu',
    preChangeRetentionHint:
      'Tómt = óvirkt. Fyrsta stillingaskrif eftir kyrrðartímabil frystir hér fyrra ástand (uppruni „fyrir breytingu“); nýjustu eru geymd upp að fjöldanum — eigin, klippanleg varðveisla.',
    diffTitle: 'Forskoðun breytinga',
    diffFailed: 'Forskoðun mistókst',
    diffRetry: 'Reyna aftur',
    diffCounts: '{changed} breytist · {missing} verður búið til · {extra} umfram · {equal} eins',
    diffChanged: 'breytist',
    diffMissing: 'yrði búið til',
    diffExtra: 'yrði eytt',
    diffJsonb: 'jsonb-tilvísanir ekki sannreynanlegar fyrir beitingu',
    diffSecret: 'innsigluð svæði, ósambærileg',
    diffMore: '{n} í viðbót…',
    diffNeeded: 'Ræsing virkjast þegar forskoðunin endurspeglar valið.',
    phase: 'Staða',
    phaseRunning: 'í gangi',
    phaseComplete: 'lokið',
    phaseError: 'villa',
    secrets: 'Leyndarmál',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'staðgenglar',
    size: 'Stærð',
    created: 'Búið til',
    destination: 'Áfangastaður',
    download: 'Sækja .tvbk',
    deleteCheckpoint: 'Eyða checkpoint',
    noCheckpoints: 'Engin checkpoint — búðu til eitt frá áfangastað.',

    // Round #156 (dialog standard): la superficie di lettura completa del
    // record di archivio — righe di dettaglio per i campi mai mostrati in tabella.
    families: 'Fjölskyldur',
    generation: 'Kynslóð',
    completedAt: 'Lokið þann',
    errorDetail: 'Nánar um villu',
    manifest: 'Manifest',
    restoreHint:
      'Hlaðið upp .tvbk-artefakti: skoðarinn sýnir hvað það inniheldur, síðan velur þú hvað á að endurheimta og hvernig.',
    uploadFile: 'Hlaða upp .tvbk-skrá',
    uploading: 'Hleð upp…',
    uploadFailed: 'Ekki tókst að opna artefaktið',
    explorerTitle: 'Innihald checkpoint-sins',
    checkpointFrom: 'Checkpoint af klasanum {cluster}, tekið {when} ({origin}, kynslóð {generation})',
    otherCluster: 'Þetta checkpoint var tekið á ÖÐRUM klasa ({cluster}) — endurheimt milli klasa kemur í síðara round.',
    encrypted: 'dulkóðað',
    objectsCount: '{n} hlutir',
    mode: 'Hamur',
    modeMerge: 'Merge — samræmir: upsert á völdum röðum, engu er eytt',
    modeOverwrite:
      'Overwrite — checkpoint-ið vinnur: fjölskylda sem er valin í heild er skipt út í heilu lagi (núverandi raðir sem ekki eru í checkpoint-inu hverfa)',
    restoreMasterpassHint:
      'Masterpass sem checkpoint-ið var tekið með. Án þess eru dulkóðuð leyndarmál endurheimt sem skýrir staðgenglar.',
    checkMasterpass: 'Athuga',
    masterpassOk: 'Rétt masterpass',
    masterpassWrong: 'Rangt masterpass',
    parachuteDestination: 'Fallhlífarstaður',
    parachuteHint: 'Áður en nokkur röð er snert tekur verkið sjálfvirkt checkpoint hér, frá því fyrir endurheimt.',
    summaryTitle: 'Hvað mun gerast',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'fjölskyldan í heild',
    summaryObjects: '{n} valdir hlutir',
    confirmHint: 'Sláðu inn nafn klasans ({name}) til að staðfesta — endurheimt endurskrifar yfirlýstu stillingarnar.',
    confirmField: 'Nafn klasans',
    startRestore: 'Endurheimta',
    restoreRunning: 'Endurheimt í gangi…',
    restoreDone: 'Endurheimt lokið — reconciler-arnir renna saman að nýju yfirlýsingunni.',
    restoreFailed: 'Endurheimtin mistókst',
    discard: 'Henda',
    selectionEmpty: 'Veldu að minnsta kosti eina fjölskyldu eða einn hlut.'
  },

  backup: {
    intro: {
      title: 'Öryggisafritun gagna sýndarvéla og gáma',
      subtitle: 'Byggingareiningarnar sem utanaðkomandi öryggisafritunarhugbúnaður notar',
      whatItIs:
        'TVirt býður upp á fjórar frumeiningar: quiesced-skyndimyndir, breytingarakningu fyrir hvern disk, NBD-útflutning eingöngu til lestrar og útflutning stillinganna. Það eru Veeam, Bacula, Acronis og félagar sem stýra þeim.',
      whatItIsNot:
        'TVirt er ekki öryggisafritunarvara: það áætlar ekkert, beitir engri varðveislu og geymir ekkert safn af gögnunum þínum. Varðveisla, skrár yfir afrit og endurheimtarstefnur eru áfram hjá hugbúnaðinum sem þú notar nú þegar.'
    },
    cbt: {
      title: 'Breytingarakning',
      colVm: 'VM',
      colDisk: 'Diskur',
      colState: 'Staða',
      colBitmaps: 'Bitakort',
      colObservedAt: 'Séð',
      colChangeId: 'Change ID',
      colMechanic: 'Kerfi',
      stateActive: 'Virkt',
      stateInactive: 'Óvirkt',
      stateInconsistent: 'Ósamkvæmt — næsta afrit verður að vera fullt',
      stateBroken: 'Keðja rofin — slökktu, kveiktu svo sem nýja keðju',
      stateSnapshots: 'Alltaf á — delta milli skyndimynda',
      stateUnavailable: 'Ekki tiltækt á þessum diski',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitakort',
        'rbd-snapdiff': 'Ceph skyndimyndadiff',
        'lvm-thin-delta': 'Thin pool delta',
        none: 'Ekkert'
      },
      empty:
        'Enginn VM-diskur. Rakning er lesin fyrir hvern disk: kveiktu á henni á qcow2 diski eða taktu skyndimyndir á rbd/SAN.',
      chainBroken: 'Keðja rofin',
      chainBrokenText:
        'Rofin af {reason}: {bitmaps}. Slökktu á bitakortinu (keðjan er glötuð, næsta afrit er fullt) og kveiktu svo á því sem nýrri keðju.',
      lineages: 'Tímabil',
      epochFrozen: 'fryst í skyndimynd {snapshot}',
      epochLost: 'glatað ({cause})',
      epochRecording: 'skráir á hausnum',
      milestones: 'Áfangar (skyndimyndir)',
      enable: 'Kveikja á rakningu',
      disable: 'Slökkva',
      reset: 'Endurstilla',
      changedAreas: 'Breytt svæði',
      denied: 'Þú hefur ekki heimild á þessari VM',
      enableTitle: 'Kveikja á breytingarakningu',
      disableTitle: 'Slökkva á breytingarakningu',
      resetTitle: 'Endurstilla bitakortið',
      areasTitle: 'Breytt svæði',
      bitmapName: 'Nafn bitakorts',
      bitmapNameHint: 'Þitt eigið nafn: tvirt- og tvbk- tilheyra kerfinu',
      granularity: 'Kornastærð (bæti)',
      granularityHint: 'Veldi af tveimur; sjálfgefið 65536',
      bitmap: 'Bitakort',
      disableHint: 'Fjarlægir bitakortið og alla tímabilasögu þess: næsta afrit verður að vera fullt.',
      resetHint: 'Tæmir bitakortið — nýr grunnur: change ID eldra en endurstillingin er ekki lengur samsetjanlegt.',
      areasFrom: 'Frá skyndimynd',
      areasTo: 'Til skyndimyndar',
      areasRun: 'Reikna',
      areasResult: '{count} breytt svæði, {bytes}',
      areasEmpty: 'Engin breytt svæði milli skyndimyndanna tveggja',
      areasZero: 'núll',
      areasMore: 'fyrstu {shown} af {count} sýnd',
      submit: 'Staðfesta',
      error: 'Rakningaraðgerðin mistókst'
    },
    exports: {
      title: 'Opnir NBD-útflutningar',
      colVm: 'VM',
      colDisk: 'Diskur',
      colSnapshot: 'Skyndimynd',
      colBitmap: 'Bitakort',
      colPhase: 'Áfangi',
      colNode: 'Hnútur',
      colEndpoint: 'Endapunktur',
      colExpires: 'Rennur út',
      colCreated: 'Opnað',
      colError: 'Villa',
      phase: {
        preparing: 'Undirbúningur',
        ready: 'Tilbúið',
        closed: 'Lokað',
        error: 'Mistókst'
      },
      expiresIn: 'eftir {minutes} mín',
      expired: 'útrunnið',
      empty: 'Enginn útflutningur. Lestrarlota ber einn disk við eina skyndimynd til NBD-biðlara; skriflota fyllir ósnertan disk stöðvaðrar VM. Báðar deyja við rennslu.',
      endpointHint: 'TLS með CA klasans; nafn útflutningsins er miðinn — hann deyr með setunni',
      closeDenied: 'Þú hefur ekki heimild til að loka útflutningum þessarar VM',
      open: 'Opna NBD-útflutning',
      openTitle: 'Opna NBD-útflutning',
      openDisk: 'Diskur',
      openBitmap: 'Bitakort (valfrjálst)',
      openBitmapHint:
        'Birtir tímabil bitakortsins sem fryst var í þessari skyndimynd sem meta-context breyttra extenta (aðeins qcow2 diskar)',
      openTtl: 'Líftími (mínútur)',
      openSubmit: 'Opna',
      openError: 'Ekki tókst að opna útflutninginn',
      colMode: 'Hamur',
      mode: {
        read: 'Lestur',
        write: 'Skrif'
      },
      caCertificate: 'CA klasans',
      caCopy: 'Afrita PEM',
      caDownload: 'Sækja ca-cert.pem',
      caHint: 'Skrifaðu PEM í ca-cert.pem í einkamöppu og tengstu með nbds://…?tls-certificates=<mappa> (nbdcopy, nbdinfo) eða --object tls-creds-x509,dir=<mappa>,endpoint=client (qemu-img)',
      caAbsent: 'Lotan ber enga CA (engin PKI)',
      openWrite: 'Opna skrifútflutning',
      openWriteTitle: 'Opna skrifútflutning',
      openWriteIntro: 'Diskurinn verður að vera ósnertur: fæddur tómur, aldrei skrifaður, án skyndimyndar; VM stöðvuð. Endurheimtin FYLLIR diskinn, hún lagar hann ekki. Meðan lotan er opin ræsir VM ekki, tekur ekki skyndimynd, klónast ekki og diskurinn færist ekki.',
      openWriteSubmit: 'Opna',
      openWriteError: 'Ekki tókst að opna skrifútflutninginn',
      openWriteDenied: 'Þig vantar vm.restore.data á þessari VM',
      openWriteStopped: 'Stöðvaðu VM til að opna skrifútflutning',
      fromDescription: 'Búa til VM úr lýsingu',
      fromDescriptionTitle: 'Búa til VM úr lýsingu',
      fromDescriptionIntro: 'Lýsingin frá export-vm-meta kemur til baka sem stöðvuð VM með tóma diska í lýstri rúmfræði — tilbúin fyrir skrifútflutningana, disk fyrir disk. Bætin fara ekki hér um: restore-disk (CLI) eða NBD-biðlari afritunarvörunnar ber þau.',
      fromDescriptionDoc: 'Lýsing (JSON)',
      fromDescriptionDocHint: 'Límdu skjalið frá export-vm-meta eða veldu skrána',
      fromDescriptionFile: 'Velja skrá…',
      fromDescriptionInvalid: 'Textinn er ekki JSON-skjal',
      fromDescriptionName: 'Nafn nýju VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Heimascope þitt',
      fromDescriptionStorage: 'Diskageymsla',
      fromDescriptionStorageHint: 'Hver diskur fæðist hér, á sjálfgefnu sniði geymslunnar',
      fromDescriptionMetadataStorage: 'Lýsigagnageymsla',
      fromDescriptionSameAsStorage: 'Sama og diskarnir',
      fromDescriptionBridge: 'Brú',
      fromDescriptionBridgeHint: 'Án brúar eða nets fæðist VM án netkorta',
      fromDescriptionNetwork: 'Rökrænt net (fabric/net)',
      fromDescriptionSubmit: 'Búa til',
      fromDescriptionError: 'Ekki tókst að búa til VM',
      fromDescriptionDone: 'VM búin til: {name}',
      fromDescriptionOpen: 'Opna VM',
      fromDescriptionDenied: 'Þig vantar vm.create',
      fromDescriptionStillRunning: 'Stofnunin er enn í gangi: beðið áfram'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Gagnaafrit sýndarvéla',
      titleOnVm: 'Gagnaafrit',
      empty: 'Ekkert afrit. Afrit flytur diskana, UEFI-varstore og vTPM-stöðuna á áfangastað og lifir sýndarvélina af.',
      colVm: 'Sýndarvél',
      colCreated: 'Tekið',
      colPhase: 'Niðurstaða',
      colDestination: 'Áfangastaður',
      colContains: 'Innihald',
      colSize: 'Stærð',
      colOrigin: 'Uppruni',
      colMode: 'Tegund',
      retentionChip: 'Varðveisla',
      retentionHint:
        'Varðveisla áfangastaðarins getur eytt þessu afriti án þess að spyrja: það fæddist af áætlun. Handvirkum afritum er aldrei sópað burt.',
      policyRemoved: 'Policy fjarlægð: {name}',
      policyRemovedHint:
        'Policy sem áætlaði þetta backup er ekki lengur til: engin retention stjórnar því (aldrei grisjað sjálfkrafa) — eyddu því handvirkt þegar þess er ekki lengur þörf.',
      phase: {
        running: 'Í gangi',
        complete: 'Lokið',
        error: 'Mistókst'
      },
      origin: {
        manual: 'Handvirkt',
        schedule: 'Áætlað'
      },
      mode: {
        full: 'Fullt',
        incremental: 'Stigvaxandi'
      },
      contains: {
        disks: 'Diskar',
        varstore: 'UEFI-varstore',
        vtpm: 'vTPM-staða',
        snapshots: 'Skyndimyndir'
      },
      vmState: {
        stopped: 'Sýndarvél slökkt',
        running: 'Sýndarvél í gangi (heit)'
      },
      artifactClass: { metadata: 'Lýsigögn', data: 'Gögn', secret: 'Leyndarmál' },
      detail: {
        tabOverview: 'Yfirlit',
        tabArtefact: 'Gripur',
        id: 'Auðkenni',
        scope: 'Umfang',
        vmState: 'Staða sýndarvélar við afritun',
        pointInTime: 'Augnablik gagnanna',
        completedAt: 'Lauk',
        node: 'Hnútur sem afritaði',
        error: 'Villa',
        path: 'Mappa á geymslunni',
        checksum: 'sha256 fyrir manifest',
        secretsExposed: 'Viðkvæmt efni ódulkóðað',
        secretsExposedYes: 'Já — áfangastaðurinn dulkóðar ekki',
        secretsExposedNo: 'Nei',
        baseBackup: 'Grunnafrit',
        tabManifest: 'Manifest',
        manifestHint:
          'Skrá gripsins í læsilegu formi: ein skrá á línu með sínu sha256. Möppuna má sannreyna án TVirt — qemu-img, tar og jq duga.',
        manifestEmpty: 'Manifest telur engar skrár.',
        manifestError: 'Manifest er ekki læsilegt',
        colEntry: 'Skrá',
        colClass: 'Flokkur',
        colSha: 'sha256'
      },
      create: {
        action: 'Taka afrit núna',
        title: 'Taka afrit núna',
        submit: 'Hefja afritun',
        destination: 'Áfangastaður',
        destinationHint: 'Aðeins áfangastaðir sem taka við afritum.',
        noDestinations: 'Enginn áfangastaður tekur við afritum: búðu til einn undir Kerfi → Checkpoints.',
        contentsHint:
          'Allir diskar fylgja með, ásamt UEFI-varstore og vTPM-stöðunni. Þau tvö síðarnefndu eru kjarninn: innsigluð gestavél verður að ræsast aftur.',
        error: 'Afritunin fór ekki af stað',
        stillRunning: 'Afritun enn í gangi — afritunin heldur áfram þótt þú lokir.',
        vmRunning:
          'Sýndarvélin er {phase}: afritun krefst stöðugrar sýndarvélar — slökktrar fyrir kalda afritun, í gangi fyrir heita.'
      },
      restore: {
        action: 'Endurheimta',
        title: 'Endurheimta',
        intro: 'Endurheimt er óafturkræf. Veldu hvert gögnin fara aftur: í nýja vél, eða yfir þá upprunalegu.',
        modeNewVm: 'Endurheimta í NÝJA sýndarvél',
        modeNewVmHint:
          'Snertir ekkert af því sem til er — þetta er kosturinn sem afrit er sannreynt með. Nýtt auðkenni og nýslegin MAC-vistföng.',
        modeOver: 'Skrifa yfir upprunalegu sýndarvélina',
        modeOverHint: 'Eyðir núverandi gögnum marksýndarvélarinnar, án afturhvarfs. Sýndarvélin verður að vera slökkt.',
        newName: 'Nafn nýju sýndarvélarinnar',
        newNameHint: 'Það verður að vera laust í umfangi áfangastaðarins.',
        storage: 'Geymsla fyrir diskana',
        storageHint: 'Skylda: manifest skráir stærð og snið disks, aldrei geymsluna sem hann lá á.',
        metadataStorage: 'Geymsla fyrir varstore og vTPM',
        metadataStorageHint: 'Hvar UEFI-auðkennið og vTPM-staðan lenda.',
        sameAsStorage: 'Sama og diskarnir',
        bridge: 'Bridge hýsilsins',
        bridgeHint:
          'Hvert skráð netkort kemur aftur á þessari bridge með nýju MAC. Sé reitnum sleppt fæðist sýndarvélin án korta — öruggara sjálfgildi.',
        overwriteTitle: 'Þú ert í þann mund að skrifa yfir þessa sýndarvél',
        overwriteName: 'Nafn',
        overwriteId: 'Auðkenni',
        overwriteDisks: 'Diskar sem verða yfirskrifaðir',
        overwriteNoDisks: 'Engir diskar.',
        overwriteKeeps:
          'Ósnert standa auðkenni, nafn, umfang, netkort og MAC-vistföng: afrit eru GÖGNIN, stillingarnar eru checkpointið.',
        confirmField: 'Nafn sýndarvélarinnar',
        confirmHint: 'Sláðu inn {name} til að staðfesta.',
        targetLoading: 'Les marksýndarvélina…',
        targetRunning:
          'Marksýndarvélin er {phase}: endurheimt skrifar bætin undir gestinum upp á nýtt og krefst þess því að hún sé slökkt.',
        targetGone: 'Upprunalega sýndarvélin er ekki lengur læsileg: endurheimt í nýja sýndarvél stendur eftir.',
        onlyComplete: 'Afritið er {phase}: aðeins fullklárað afrit getur endurheimt.',
        submitNewVm: 'Endurheimta í nýju sýndarvélina',
        submitOver: 'Skrifa yfir',
        error: 'Endurheimtin fór ekki af stað',
        stillRunning: 'Endurheimt enn í gangi — að afrita heila diska tekur tíma.'
      }
    },
    guest: {
      title: {
        ct: 'Gagnaafrit gáma',
        app: 'Gagnaafrit Appa'
      },
      tabTitle: 'Afrit',
      empty: 'Engin afrit. Afrit flytur varanleg gögn á áfangastað og lifir hlut sinn.',
      colSubject: {
        ct: 'Gámur',
        app: 'App'
      },
      colCreated: 'Tekið',
      colPhase: 'Niðurstaða',
      colDestination: 'Áfangastaður',
      colContains: 'Innihald',
      colSize: 'Stærð',
      colOrigin: 'Uppruni',
      policyRemoved: 'Policy fjarlægð: {name}',
      policyRemovedHint:
        'Policy sem áætlaði þetta backup er ekki lengur til: engin retention stjórnar því (aldrei grisjað sjálfkrafa) — eyddu því handvirkt þegar þess er ekki lengur þörf.',
      phase: {
        running: 'Í gangi',
        complete: 'Lokið',
        error: 'Mistókst'
      },
      origin: {
        manual: 'Handvirkt',
        schedule: 'Áætlað'
      },
      state: {
        stopped: 'Hlutur stöðvaður',
        running: 'Hlutur í gangi (frystur)'
      },
      contains: {
        rootfs: 'Rootfs-tré',
        config: 'Stillingar',
        volumes: 'Varanleg bindi',
        root: 'Varanleg root'
      },
      artifactClass: {
        metadata: 'Lýsigögn',
        data: 'Gögn',
        secret: 'Leyndarmál'
      },
      create: {
        action: 'Taka afrit núna',
        title: 'Nýtt afrit',
        submit: 'Hefja afritið',
        error: 'Afritið fór ekki í gang',
        destination: 'Áfangastaður',
        destinationHint: 'Aðeins áfangastaðir sem taka við gagnaafritum.',
        noDestinations: 'Enginn áfangastaður tekur við gagnaafritum: bættu „Gagnaafrit“ við áfangastað.',
        hint: {
          ct: 'Allt rootfs-tréð ferðast, trúverðuglega (tölulegir eigendur, xattr, ACL), auk yfirlýstra stillinga í manifestinu. Gámur í gangi er FRYSTUR meðan pakkað er: crash-consistent afrit, yfirlýst.',
          app: 'AÐEINS varanlegu bindin (og varanlega rootin) ferðast, auk stillinganna í manifestinu. Hverfult er útilokað með staðfestingu og manifestið nefnir það; env-gildi yfirlýst leynileg ferðast ekki.'
        },
        stillRunning: 'Afrit enn í gangi — að pakka heilum trjám tekur tíma.'
      },
      detail: {
        tabOverview: 'Yfirlit',
        tabManifest: 'Manifest',
        id: 'Auðkenni',
        scope: 'Umfang',
        state: 'Ástand við afritun',
        pointInTime: 'Gögn á augnabliki',
        completedAt: 'Lauk',
        node: 'Hnútur sem afritaði',
        error: 'Villa',
        path: 'Mappa á geymslunni',
        checksum: 'sha256 manifestsins',
        manifestHint:
          'Vísir artefaktsins: ein færsla á skrá með sha256 — án tætigilda er „afritið er til“ trúaratriði.',
        manifestError: 'Ekki er hægt að lesa manifestið',
        manifestEmpty: 'Engin artefökt í manifestinu.',
        colEntry: 'Skrá',
        colClass: 'Flokkur',
        colSha: 'sha256',
        excluded: 'Útilokað með staðfestingu (ferðast ekki)',
        secretKeys: 'Sleppt leynilegum env-lyklum (#307) — sláðu þá inn aftur eftir endurheimt'
      },
      restore: {
        action: 'Endurheimta',
        title: 'Endurheimt',
        submit: 'Endurheimta',
        error: 'Endurheimtin fór ekki í gang',
        stillRunning: 'Endurheimt enn í gangi — að afpakka heilum trjám tekur tíma.',
        onlyComplete: 'Afritið er {phase}: aðeins lokið afrit getur endurheimt.',
        asNew: {
          ct: 'Í NÝJAN gám — eyðileggur ekkert: látbragðið sem afrit er sannreynt með',
          app: 'Í NÝTT App — eyðileggur ekkert: látbragðið sem afrit er sannreynt með'
        },
        over: {
          ct: 'YFIR upprunagáminn — allt rootfs-tréð er skipt út',
          app: 'YFIR uppruna-Appið — innihald hvers varanlegs bindis er skipt út'
        },
        name: 'Nafn nýja hlutarins',
        storage: 'Geymsla',
        storageHint: 'Þar sem endurheimtu gögnin lenda — manifestið skráir aldrei týnda poolinn.',
        storageDeclared: 'Geymslurnar yfirlýstar í manifestinu',
        bridge: 'Brú hýsils',
        bridgeHint:
          'Hvert skráð netkort kemur aftur á þessa brú með nýtt MAC. Tómt = fæðist ótengt, öruggasta sjálfgefið.',
        node: 'Hnútur',
        nodeHint: 'Meðlimurinn sem Appið endurfæðist á: hnúturinn er klasaauðkenni og kemur aldrei úr manifestinu.',
        secretKeysWarning:
          'Env-gildi yfirlýst leynileg ferðast ekki í afritinu: endurfædda eintakið vill fá þau slegin inn aftur (task-loggurinn nefnir lyklana).',
        overInventory: 'Þú ert að fara að yfirskrifa þennan hlut',
        confirmType: 'Sláðu inn {name} til að staðfesta',
        targetGone: 'Ekki er lengur hægt að lesa upprunahlutinn: endurheimt sem nýtt er enn í boði.',
        targetLoading: 'Les markhlutinn…',
        targetRunning: 'Markhluturinn er í gangi: endurheimt skiptir út bætunum undir gestinum og vill hann stöðvaðan.'
      }
    }
  }
}
